import React from "react";

const BlueCubeSpinner = () => {
  return (
    <div
      aria-label="loading"
      className="inline-block ml-2"
      style={{ width: 30, height: 30 }}
    >
      <div
        className="relative"
        style={{ width: 30, height: 30, perspective: 600 }}
      >
        <div
          className="relative animate-[cube-spin_3s_linear_infinite]"
          style={{
            width: 30,
            height: 30,
            transformStyle: "preserve-3d",
          }}
        >
          {[
            "front",
            "back",
            "right",
            "left",
            "top",
            "bottom",
          ].map((face) => {
            let transform;
            switch (face) {
              case "front":
                transform = "translateZ(15px)";
                break;
              case "back":
                transform = "rotateY(180deg) translateZ(15px)";
                break;
              case "right":
                transform = "rotateY(90deg) translateZ(15px)";
                break;
              case "left":
                transform = "rotateY(-90deg) translateZ(15px)";
                break;
              case "top":
                transform = "rotateX(90deg) translateZ(15px)";
                break;
              case "bottom":
                transform = "rotateX(-90deg) translateZ(15px)";
                break;
              default:
                transform = "none";
            }
            return (
              <div
                key={face}
                className="absolute box-border border border-[#6bb6ff] bg-transparent"
                style={{
                  width: 30,
                  height: 30,
                  transform,
                }}
              />
            );
          })}
        </div>
      </div>
      {/* cube-spin keyframes are defined globally in Tailwind config or main CSS */}
    </div>
  );
};

export default BlueCubeSpinner;
